import axios from 'axios';
import toast from 'react-hot-toast';

// Auth context를 저장할 변수 (전역으로 사용)
let authContext = null;

// Auth context를 설정하는 함수
export const setAuthContext = (auth) => {
    authContext = auth;
};

// 토큰 재발급 함수
// const reTokenIssue = async (auth) => {
//     const params = JSON.stringify({
//         "accessToken": auth.tokens.accessToken,
//         "refreshToken": auth.tokens.refreshToken
//     });

//     try {
//         const response = await axios.post(`${process.env.REACT_APP_API_URL}/reissue`, params, {
//             headers: { "Content-Type": "application/json" },
//         });
        
//         const msg = response.data.data;
//         auth.setTokens({
//             'accessToken': msg.accessToken,
//             'refreshToken': msg.refreshToken
//         });

//         // 토큰을 localStorage에도 저장
//         localStorage.setItem('accessToken', msg.accessToken);
//         localStorage.setItem('refreshToken', msg.refreshToken);

//         return true;
//     } catch (error) {
//         if (error.response?.data?.code === 1005) {
//             alert("세션이 종료되었습니다. 다시 로그인하십시오");
//             auth.logout();
//         }
//         return false;
//     }
// };

// Base configuration
const config = {
    headers: {
        'Content-Type': 'application/json',
    },
    baseURL: process.env.REACT_APP_API_URL,
};

// Create axios instance
export const axiosClient = axios.create(config);

// Create axios instance with auth
export const axiosClientWithAuth = axios.create(config);

// Request interceptor for adding auth token
axiosClientWithAuth.interceptors.request.use(
    (config) => {
        // localStorage에서 토큰 가져오기
        let storedToken = localStorage.getItem('accessToken');
        
        // localStorage에 없으면 authContext에서 가져오기
        if (!storedToken && authContext?.tokens?.accessToken) {
            storedToken = authContext.tokens.accessToken;
        }

        if (storedToken) {
            config.headers['Authorization'] = storedToken;
        }

        return config;
    },
    (error) => {
        console.log('Request interceptor error:', error);
        return Promise.reject(error);
    }
);

// Response interceptor for handling errors
axiosClientWithAuth.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (!error.response || error.code === 'ERR_NETWORK') {
            //toast.error('네트워크 오류: 서버에 연결할 수 없습니다.');
            toast.error('세션이 종료되었습니다. 다시 로그인하십시오');
            authContext.logout();
            return Promise.reject(error);
        }

        const originalRequest = error.config;
        const status = error.response.status;

        if (status === 401) {
            // 무한루프 방지
            if (originalRequest && !originalRequest._retry) {
                originalRequest._retry = true;
            }

            toast.error('세션이 종료되었습니다. 다시 로그인하십시오');

            if (authContext && typeof authContext.logout === 'function') {
                authContext.logout();
            } else {
                window.location.href = '/login';
            }

            return Promise.reject(error);
        } else if (status === 404) {
            toast.error('요청한 리소스를 찾을 수 없습니다.');
        } else if (status >= 500) {
            toast.error('서버 오류가 발생했습니다.');
        }

        return Promise.reject(error);
    }
);

// API service functions
export const apiService = {
    // GET request
    get: (url, config = {}) => {
        return axiosClientWithAuth.get(url, config);
    },

    // POST request
    post: (url, data, config = {}) => {
        return axiosClientWithAuth.post(url, data, config);
    },

    // PUT request
    put: (url, data, config = {}) => {
        return axiosClientWithAuth.put(url, data, config);
    },

    // DELETE request
    delete: (url, config = {}) => {
        return axiosClientWithAuth.delete(url, config);
    },

    // POST with FormData (for file uploads)
    postFormData: (url, formData, config = {}) => {
        return axiosClientWithAuth.post(url, formData, {
            ...config,
            headers: {
                ...config.headers,
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    // PUT with FormData (for file uploads)
    putFormData: (url, formData, config = {}) => {
        return axiosClientWithAuth.put(url, formData, {
            ...config,
            headers: {
                ...config.headers,
                'Content-Type': 'multipart/form-data',
            },
        });
    },
};

export default apiService;
